import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'
import {
  LANGUAGE_CODE_FRENCH,
  LANGUAGE_CODE_KOREAN,
  LANGUAGE_CODE_SPANISH,
} from '../utilities/language'

export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_TITLE: string =
  'Your Coffee Shop’s Spotify Account Could Cost You $150,000 — Per Song'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_TITLE_ES: string =
  'La cuenta de Spotify de tu cafetería podría costarte 150.000 dólares — por canción'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_TITLE_FR: string =
  'Le compte Spotify de votre café pourrait vous coûter 150 000 $ — par chanson'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_TITLE_KO: string =
  '당신의 커피숍 스포티파이 계정, 곡당 15만 달러의 비용을 초래할 수도 있습니다'

export const SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML: JSX.Element = (
  <>
    Your Coffee Shop’s Spotify Account Could Cost You $150,000&nbsp;— Per Song
  </>
)
export const SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_ES: JSX.Element = (
  <>
    La cuenta de Spotify de tu cafetería podría costarte 150.000 dólares&nbsp;—
    por canción.
  </>
)
export const SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_FR: JSX.Element = (
  <>
    Le compte Spotify de votre café pourrait vous coûter
    150&nbsp;000&nbsp;$&nbsp;— par chanson.
  </>
)
export const SPOTIFY_IN_COFFEE_SHOPS_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      당신의
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      커피숍
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      스포티파이
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      계정,
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      곡당
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      15만
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      달러의
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      비용을
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      초래할
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      수도
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      있습니다.
    </span>
  </>
)

export const SPOTIFY_IN_COFFEE_SHOPS_PAGE_ID: string =
  '372B1308-03BA-487A-9002-492F2F91A6E1'

export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE: string =
  '/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_ES: string =
  '/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_FR: string =
  '/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_KO: string =
  '/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars'

export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_URL: string =
  HOST + SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_ES
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_URL_ES: string =
  HOST + '/' + LANGUAGE_CODE_SPANISH + SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_ES
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_URL_FR: string =
  HOST + '/' + LANGUAGE_CODE_FRENCH + SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_FR
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_URL_KO: string =
  HOST + '/' + LANGUAGE_CODE_KOREAN + SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'background music streaming, royalties-free music, legal risk, workplace music, compliance, business background music, reception area music, licensed music'
export const ARTICLE_KEYWORDS_ES =
  'Música de fondo por streaming, música libre de derechos, riesgo legal, música en el lugar de trabajo, cumplimiento normativo, música de fondo para negocios, música para áreas de recepción, música con licencia'
export const ARTICLE_KEYWORDS_FR =
  "Streaming de musique d'ambiance, musique libre de droits, risque juridique, musique au travail, conformité, musique d'ambiance commerciale, musique d'accueil, musique sous licence"
export const ARTICLE_KEYWORDS_KO =
  '배경 음악 스트리밍, 저작권 무료 음악, 법적 리스크, 업무 공간 음악, 규정 준수, 상업용 배경 음악, 접수처 음악, 라이선스 음악'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '80768144-9651-4B47-9885-794FD94A7C62.avif'
  : HOST + '/images/80768144-9651-4B47-9885-794FD94A7C62.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '80768144-9651-4B47-9885-794FD94A7C62.jpg'
  : HOST + '/images/80768144-9651-4B47-9885-794FD94A7C62.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '3649782C-71A5-427B-81AE-19D302AF2819.jpg'
  : HOST + '/images/3649782C-71A5-427B-81AE-19D302AF2819.jpg'
export const SPOTIFY_IN_COFFEE_SHOPS_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'D745BC71-2E8E-44C7-B730-F3BE513C5BC7.png?v=2'
  : HOST + '/images/D745BC71-2E8E-44C7-B730-F3BE513C5BC7.png?v=2'

export const ARTICLE_IMAGE_AVIF_ES_FR_KO: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'A2DE9AFC-8ECF-46D3-B3AE-18052073D6D5.avif?v=4'
  : HOST + '/images/A2DE9AFC-8ECF-46D3-B3AE-18052073D6D5.avif?v=4'
export const ARTICLE_IMAGE_JPEG_ES_FR_KO: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'A2DE9AFC-8ECF-46D3-B3AE-18052073D6D5.jpg?v=44'
  : HOST + '/images/A2DE9AFC-8ECF-46D3-B3AE-18052073D6D5.jpg?v=44'
export const OPEN_GRAPH_IMAGE_JPEG_ES_FR_KO: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '6445410B-B0B4-484F-9DC7-63D5C0062916.jpg'
  : HOST + '/images/6445410B-B0B4-484F-9DC7-63D5C0062916.jpg'
export const SPOTIFY_IN_COFFEE_SHOPS_JSON_LD_IMAGE_1200_X_1200_ES_FR_KO: string =
  USE_CDN
    ? PRACTICAL_STREAM_CDN_ADDRESS + '0B28DF42-412A-458E-AB14-E9045D4C3B43.png'
    : HOST + '/images/0B28DF42-412A-458E-AB14-E9045D4C3B43.png'

export const ARTICLE_SUMMARY: string =
  'Most café and coffee shop owners have no idea they’re breaking copyright law every single day. It can cost them hundreds of thousands, even millions of dollars. This article discusses the solution with licensed background music streaming services, and in particular recommends the most affordable one, called Practical Stream.'
export const ARTICLE_SUMMARY_ES: string =
  'La mayoría de los propietarios de cafeterías no tienen ni idea de que están infringiendo las leyes de derechos de autor todos los días. Esto puede costarles cientos de miles, e incluso millones, de dólares. Este artículo aborda la solución mediante servicios de *streaming* de música ambiental con licencia y, en particular, recomienda la opción más asequible: Practical Stream.'
export const ARTICLE_SUMMARY_FR: string =
  "La plupart des propriétaires de cafés ignorent qu'ils enfreignent quotidiennement la législation sur le droit d'auteur. Cela peut leur coûter des centaines de milliers, voire des millions de dollars. Cet article présente la solution offerte par les services de streaming de musique d'ambiance sous licence et recommande tout particulièrement le plus abordable d'entre eux, baptisé Practical Stream."
export const ARTICLE_SUMMARY_KO: string =
  '대부분의 카페 주인들은 매일 저작권법을 위반하고 있다는 사실조차 모릅니다. 이로 인해 수십만 달러, 심지어 수백만 달러의 손실을 입을 수 있습니다. 이 글에서는 저작권이 있는 배경 음악 스트리밍 서비스를 이용하는 해결책을 제시하고, 특히 가장 저렴한 서비스인 Practical Stream을 추천합니다.'

export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_PUBLISHED_STR: string = '2026-3-27'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_CREATED_STR: string = '2026-3-27'
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_PUBLISHED: Date = new Date(
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_PUBLISHED_STR,
)
export const SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_CREATED: Date = new Date(
  SPOTIFY_IN_COFFEE_SHOPS_ARTICLE_CREATED_STR,
)
